import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';
import { W as WppIcon } from './WppIcon.js';

const wppIconCss = ":host{display:-ms-inline-flexbox;display:inline-flex;color:var(--wpp-prop-icon-color)}";

const WppIconWifiOff$1 = /*@__PURE__*/ proxyCustomElement(class WppIconWifiOff extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.size = 'm';
    this.width = undefined;
    this.height = undefined;
    this.color = 'var(--wpp-icon-color)';
  }
  render() {
    return (h(WppIcon, { name: "wpp-icon-wifi-off", width: this.width, height: this.height, size: this.size, color: this.color }, h("path", { d: "M3.02426 2.17574C2.78995 1.94142 2.41005 1.94142 2.17574 2.17573C1.94142 2.41004 1.94142 2.78994 2.17573 3.02425L4.8672 5.71577C4.29046 6.08352 3.74455 6.51923 3.24087 7.02291C2.84947 7.41431 2.46994 7.87839 2.12582 8.37444C1.93694 8.6467 2.00453 9.02054 2.2768 9.20942C2.54907 9.3983 2.9229 9.3307 3.11178 9.05843C3.41717 8.61823 3.7519 8.20893 4.0894 7.87143C4.5957 7.36513 5.15079 6.93737 5.73954 6.58814L7.0127 7.86132C6.45958 8.15485 5.94018 8.53455 5.47432 9.00041C4.98585 9.48888 4.58742 10.0404 4.28118 10.6458C4.13161 10.9415 4.25007 11.3024 4.54577 11.452C4.84146 11.6016 5.20242 11.4831 5.35198 11.1874C5.60107 10.695 5.92459 10.2472 6.32284 9.84893C6.79484 9.37693 7.33436 9.0136 7.9103 8.75894L9.45478 10.3034C8.61266 10.4237 7.80097 10.8077 7.15317 11.4555C6.79564 11.813 6.51054 12.2407 6.30458 12.7114C6.17174 13.015 6.31016 13.3687 6.61374 13.5016C6.91732 13.6344 7.2711 13.496 7.40393 13.1924C7.5516 12.8549 7.75328 12.5524 8.00169 12.304C8.73066 11.575 9.75384 11.3196 10.689 11.5377L16.9754 17.8243C17.2098 18.0586 17.5896 18.0586 17.824 17.8243C18.0583 17.59 18.0583 17.2101 17.824 16.9757L3.02426 2.17574ZM9.66733 7.12177L10.934 8.38847C11.9642 8.56663 12.9515 9.05345 13.7469 9.84893C14.1282 10.2302 14.4644 10.7012 14.7207 11.2023C14.8715 11.4973 15.233 11.6141 15.5281 11.4632C15.8231 11.3123 15.9399 10.9509 15.789 10.6558C15.4773 10.0463 15.0681 9.47303 14.5955 9.00041C13.2426 7.64752 11.4382 7.02131 9.66733 7.12177ZM7.18943 4.64382L8.17048 5.62489C10.8694 5.02239 13.8093 5.77123 15.9095 7.87143C16.2642 8.22615 16.6024 8.63547 16.8969 9.06203C17.0851 9.33475 17.4587 9.40324 17.7315 9.21502C18.0042 9.0268 18.0727 8.65313 17.8845 8.38041C17.5497 7.89541 17.1652 7.43015 16.758 7.02291C14.1684 4.43336 10.4627 3.64033 7.18943 4.64382ZM10.8481 13.5512C11.3167 14.0199 11.3167 14.7798 10.8481 15.2484C10.3794 15.7171 9.61948 15.7171 9.1508 15.2484C8.68211 14.7798 8.68211 14.0199 9.1508 13.5512C9.61948 13.0825 10.3794 13.0825 10.8481 13.5512Z", fill: "currentColor" })));
  }
  static get registryIs() { return "wpp-icon-wifi-off-v2-21-0"; }
  static get style() { return wppIconCss; }
}, [1, "wpp-icon-wifi-off", "wpp-icon-wifi-off-v2-21-0", {
    "size": [1],
    "width": [2],
    "height": [2],
    "color": [1]
  }]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["wpp-icon-wifi-off-v2-21-0"];
  components.forEach(tagName => { switch (tagName) {
    case "wpp-icon-wifi-off-v2-21-0":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, WppIconWifiOff$1);
      }
      break;
  } });
}

const WppIconWifiOff = WppIconWifiOff$1;
const defineCustomElement = defineCustomElement$1;

export { WppIconWifiOff, defineCustomElement };
